<script>
import dayjs from 'dayjs';
import flatPickr from 'vue-flatpickr-component';

export default {
  components: {
    flatPickr
  },
  props: {
    dealsStatus: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    const today = dayjs().format('YYYY-MM-DD');
    const currentMonth = dayjs().format('YYYY-MM');

    return {
      filterType: 'today',
      dailyDate: today,
      selectedMonth: currentMonth,
      customDate: '',
      rangeConfig: {
        mode: 'range',
        dateFormat: 'Y-m-d',
        maxDate: today
      }
    };
  },
  methods: {
    // Menangani pergantian tipe filter utama
    onFilterTypeChange() {
      if (this.filterType === 'today') {
        this.onDailyChange();
      } else if (this.filterType === 'weekly') {
        this.onWeeklyChange();
      } else if (this.filterType === 'monthly') {
        this.onMonthChange();
      }
    },

    // Menangani perubahan tanggal harian
    onDailyChange() {
      if (!this.dailyDate) return;
      this.$emit('filterDate', {
        startDate: this.dailyDate,
        endDate: this.dailyDate
      });
    },

    // Menangani filter minggu ini (otomatis 7 hari terakhir)
    onWeeklyChange() {
      const today = dayjs().format('YYYY-MM-DD');
      const start = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
      this.$emit('filterDate', {
        startDate: start,
        endDate: today
      });
    },

    // Menangani perubahan pilihan bulan (Bulan 1, 2, 3...)
    onMonthChange() {
      if (!this.selectedMonth) return;
      const baseDate = dayjs(this.selectedMonth + '-01');
      const start = baseDate.startOf('month').format('YYYY-MM-DD');
      const daysCount = baseDate.daysInMonth();
      const end = baseDate.date(daysCount).format('YYYY-MM-DD');

      this.$emit('filterDate', {
        startDate: start,
        endDate: end
      });
    },

    // Menangani pemilihan rentang tanggal pada picker kustom
    onCustomDateChange(selectedDates) {
      if (selectedDates && selectedDates.length === 2) {
        const start = dayjs(selectedDates[0]).format('YYYY-MM-DD');
        const end = dayjs(selectedDates[1]).format('YYYY-MM-DD');
        this.$emit('filterDate', {
          startDate: start,
          endDate: end
        });
      }
    },

    // Menangani kasus saat picker ditutup dengan hanya memilih 1 tanggal
    onCustomDateClose(selectedDates) {
      if (selectedDates && selectedDates.length === 1) {
        const single = dayjs(selectedDates[0]).format('YYYY-MM-DD');
        this.$emit('filterDate', {
          startDate: single,
          endDate: single
        });
      }
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-header align-items-center d-flex flex-wrap gap-2">
      <h4 class="card-title mb-0 flex-grow-1">Leads Recive Of Day</h4>
      <div class="flex-shrink-0 d-flex flex-wrap gap-2 align-items-center">
        <!-- Pilihan mode filter -->
        <select
          v-model="filterType"
          @change="onFilterTypeChange"
          class="form-select form-select-sm"
          style="width: auto;"
        >
          <option value="today">Harian</option>
          <option value="weekly">Minggu Ini (7 Hari)</option>
          <option value="monthly">Bulanan</option>
          <option value="custom">Custom Range</option>
        </select>

        <!-- 1. Input Harian (bisa pilih tanggal bebas) -->
        <input
          v-if="filterType === 'today'"
          v-model="dailyDate"
          @change="onDailyChange"
          type="date"
          class="form-control form-control-sm dateFilter"
          style="width: 140px;"
        />

        <!-- 2. Input Bulanan (bisa memilih Bulan 1, 2, 3, dst di tahun yang dipilih) -->
        <input
          v-if="filterType === 'monthly'"
          v-model="selectedMonth"
          @change="onMonthChange"
          type="month"
          class="form-control form-control-sm dateFilter"
          style="width: 150px;"
        />

        <!-- 3. Input Rentang Kustom (Flatpickr Range) -->
        <flat-pickr
          v-if="filterType === 'custom'"
          v-model="customDate"
          :config="rangeConfig"
          class="form-control form-control-sm dateFilter"
          placeholder="Pilih rentang tanggal"
          @on-change="onCustomDateChange"
          @on-close="onCustomDateClose"
          style="width: 200px;"
        />
      </div>
    </div>
    <!-- end card header -->

    <div class="card-body">
      <div class="table-responsive table-card">
        <table
          class="table table-borderless table-hover table-nowrap align-middle mb-0"
        >
          <thead class="table-light">
            <tr class="text-muted">
              <th scope="col">Agent</th>
              <th scope="col" style="width: 16%">Unassign</th>
              <th scope="col" style="width: 16%">Assigned</th>
            </tr>
          </thead>

          <tbody v-if="dealsStatus.length > 0">
            <tr v-for="(item, index) of dealsStatus" :key="index"> 
              <td>
                <!-- <img
                  :src="`${item.img}`"
                  alt=""
                  class="avatar-xs rounded-circle me-2 shadow"
                /> -->
                <a href="#javascript: void(0);" class="text-body fw-medium"
                  >{{item.Name}}</a
                >
              </td>
              <td class="text-center">
                <span class="badge badge-soft-primary p-2">{{item.UnassignCount}}</span>
              </td>
              <td class="text-center">
                <span class="badge badge-soft-primary p-2">{{item.CustomerCount}}</span>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td>Belum ada leads baru</td>
            </tr>
          </tbody>
          <!-- end tbody -->
        </table>
        <!-- end table -->
      </div>
      <!-- end table responsive -->
    </div>
    <!-- end card body -->
  </div>
  <!-- end card -->
</template>
